import { render } from "./CampaignRules.vue?vue&type=template&id=6fdf0db5"
import script from "./CampaignRules.vue?vue&type=script&lang=js"
export * from "./CampaignRules.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__